import AsyncStorage from "@react-native-async-storage/async-storage";
import { SecureStorage } from "@helpers/storage";
import React, { useContext, useEffect, useState } from "react";
import {
  Image,
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  Linking,
  View,
} from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

import { SafeAreaView } from "react-navigation";
import { AuthenticationIcon } from "../../components/AuthenticationIcon";
import BetterAlert from "../../components/BetterAlert";
import Button from "../../components/Button";
import IconButton from "../../components/ButtonIcon";
import Loading from "../../components/Loading";
import MessageTypeModal from "../../components/MessageTypeModal";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { AuthContext } from "../../contexts/auth";
import { getFaceIdSuportIos } from "../../helpers/DeviceUtils";
import Validate from "../../helpers/validate";
import { Login, ResendConfirmationEmail } from "../../services/Api/login";
import { IS_IOS, IS_WEB, onAuthenticate, APP_STORE_URL, PLAY_STORE_URL } from "../../services/Config";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import LinhaTexto from "./components/LinhaTexto";
import { StatusBar } from "expo-status-bar";
import { envTest } from "../../services/Api";
import queryString from 'query-string';

const securityType = IS_IOS && getFaceIdSuportIos() ? "Face ID" : "Biometria";

export default function LoginScreen({ navigation }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const {
    setIsSignUp,
    setEmailUser,
    isFirstLogin,
    setIsFirstLogin,
    tokenApi,
    getNewTokenApi,
    setRolelUser,
    setIsAdminUser,
    setLoginType,
    loginType
  } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showLoginFields, setShowLoginFields] = useState(false);

  const [emailBiometry, setEmailBiometry] = useState("");
  const [passwordBiometry, setPasswordBiometry] = useState("");

  const [validEmail, setValidEmail] = useState({
    isValid: true,
    invalidMessage: "Digite um email válido",
  });
  const [validPassword, setValidPassword] = useState({
    isValid: true,
    invalidMessage: "Digite um senha",
  });
  const [hasBiometry, setHasBiometry] = useState(null);
  const [loginByBiometry, setLoginByBiometry] = useState(false);
  const [autoLogin, setAutoLogin] = useState(false);
  const [showAlert, setShowAlert] = useState({});
  const [saveLoginAuth, setSaveLoginAuth] = useState(false);
  const [loading, setLoading] = useState({ show: false, message: "Logando" });
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [pressDigitalCredential, setPressDigitalCredential] = useState(false);
  const [teste, setTeste] = useState("");
  const [ticketParam, setTicketParam] = useState(null);
  const [scanTicket, setScanTicket] = useState(null);
  const [goHistory, setGoHistory] = useState(null);

  useEffect(() => {
    (async () => {
      const hasBiometryStorage = await AsyncStorage.getItem("biometria");
      const emailStg = await SecureStorage.getItemAsync("email");
      const passwordStg = await SecureStorage.getItemAsync("password");

      if (envTest) {
        setShowAlert({
          type: "warning",
          title: "Atenção",
          message:
            "Esta é uma versão de teste.\nNenhum pagamento com cartão será cobrado.\n Use com cautela.",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setBiometry(
              hasBiometryStorage,
              emailStg,
              passwordStg,
              setHasBiometry,
              setEmailBiometry,
              setPasswordBiometry,
              setSaveLoginAuth
            );
            setShowAlert({ ...showAlert, show: false });
          },
        });
      } else {
        setBiometry(
          hasBiometryStorage,
          emailStg,
          passwordStg,
          setHasBiometry,
          setEmailBiometry,
          setPasswordBiometry,
          setSaveLoginAuth
        );
      }

      if(IS_WEB){
        const params = queryString.parse(window.location.search);
        console.log(params); // aqui você obtém os query params
        
        if (params.ticket) {
          setLoginType("autologin");
          setTicketParam(params.ticket);
          setAutoLoginMailPass();
          setAutoLogin(true);

          // Clear query string from URL (keep only the path, no params)
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      }
      
    })();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      setEmail(emailBiometry);
      setPassword(passwordBiometry);
      setLoginByBiometry(true);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (loginByBiometry) {
      // setTimeout(() => {
      logar();
      // }, 1000);
    }
  }, [loginByBiometry]);

  useEffect(() => {
    if (autoLogin) {
      // setTimeout(() => {
      logar();
      // }, 1000);
    }
  }, [autoLogin]);

  useEffect(() => {
    if (hasBiometry == "sim" && isFirstLogin) {
      setTimeout(() => {
        onAuthenticate(setIsAuthenticated);
      }, 500);
    }
  }, [hasBiometry]);

  
  const resendConfirmationEmailApi = (userEmail, messageType) => {
    let token = tokenApi;
    if (!token) {
      token = getNewTokenApi().then();
    }
    setLoading({ message: "Enviando código de verificação", show: true });
    ResendConfirmationEmail(userEmail, token, messageType ?? 0)
      .then((response) => {
        navigation.navigate("CodeVerification", {
          codeVerification: response.confirmationNumber,
          idUser: response.idUser,
          nextPage: "Login",
          email: email,
        });
      })
      .catch((error) => {
        setShowAlert({
          type: "alert",
          title: "Erro",
          message: error.erro ?? error.reason,
          show: true,
          confirmText: "Ok",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      })
      .finally(() => {
        setLoading({
          message: "Enviando código de verificação, por favor espere.",
          show: false,
        });
      });
  };

  const onPressMessage = (messageType) => {
    setShowMessageModal(false);
    resendConfirmationEmailApi(email, messageType);
  };


  const detectMobileOS = () => {
    // no web: prefer userAgentData quando disponível
    // userAgentData: { mobile: boolean, brands: [...] }
    const nav = typeof navigator !== 'undefined' ? (navigator) : null;

    try {
      if (nav?.userAgentData) {
        // userAgentData.brands/uaList pode ter clues; mobile flag indica mobile vs desktop
        const uaData = nav.userAgentData;
        if (uaData.mobile) {
          const ua = (nav.userAgent || '').toLowerCase();
          if (/android/.test(ua)) return 'android';
          if (/iphone|ipad|ipod|ios/.test(ua)) return 'ios';
          // se quiser, inspecione uaData.brands/uaList strings
        } else {
          return 'desktop';
        }
      }

      // fallback: userAgent regex
      const ua = (nav?.userAgent || '').toLowerCase();
      if (/android/.test(ua)) return 'android';
      if (/iphone|ipad|ipod/.test(ua)) return 'ios';
      // iPadOS13+ pode reportar mac os; detectar touchscreen+Mac pode ser necessário em casos avançados
      return 'desktop';
    } catch (e) {
      return 'unknown';
    }
  }


  const handleDownloadApp = () => {
    var OsBrowser = detectMobileOS();

    if (IS_IOS) {
      // iOS App Store link
      Linking.openURL(APP_STORE_URL);
    } else if (Platform.OS === "android") {
      // Google Play Store link
      Linking.openURL(PLAY_STORE_URL);
    } else {
      if(OsBrowser === "ios"){
        //web ios
        window.open(APP_STORE_URL,"_blank");
      } else if (OsBrowser === "android"){
        // web android
        window.open(PLAY_STORE_URL,"_blank");
      } else{
        // Web fallback
        setShowAlert({
          type: "info",
          title: "Baixar App",
          message: "Para uma melhor experiência, baixe o app na App Store (iOS) ou Google Play Store (Android).",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      }
    }
  };

  if (loading.show) return <Loading message={loading.message} />;

  return (
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      enabled={true}
    >
      <StatusBar translucent={true} backgroundColor={Colors.WHITE} />
      <SafeAreaView style={styles.container}>
        <Image
          source={require("../..//../assets/images/logo-trevo-login.png")}
          style={styles.logoPequeno}
        />

        <Text style={styles.inputLogin}>Bem vindo!</Text>
        {envTest ? (
          <Text
            style={[
              styles.inputLogin,
              { marginTop: -10, color: Colors.SECONDARY },
            ]}
          >
            Versão Homologação
          </Text>
        ) : null}
        
        {/* Login fields - only shown when showLoginFields is true */}
        {showLoginFields && (
          <>
            <CaixaTextoInputIcone
              iconName={"email-outline"}
              placeholderInput={"Email"}
              keyboardType={"email-address"}
              onChangeTextInput={(email) => setEmail(email)}
              value={email}
              textContentType={"emailAddress"}
              {...validEmail}
              autoCompleteOverride={autoLogin ? "off" : undefined}
            />

            <CaixaTextoInputIcone
              iconName={"key-outline"}
              placeholderInput={"Senha"}
              onChangeTextInput={(password) => setPassword(password)}
              isSenha={true}
              value={password}
              textContentType={"password"}
              {...validPassword}
              autoCompleteOverride={autoLogin ? "off" : undefined}
            />

            <Text
              style={{
                fontSize: Fonts.FONT_SIZE_16,
                marginTop: -16,
                margin: 16,
              }}
              onPress={() => navigation.navigate("EsqueceuSenha")}
            >
              Esqueci minha senha
            </Text>

            {hasBiometry == "sim" ? (
              <AuthenticationIcon
                style={{
                  marginBottom: 16,
                  borderWidth: 1,
                  borderRadius: 8,
                  padding: 4,
                }}
                onPress={() => onAuthenticate(setIsAuthenticated)}
              />
            ) : null}

            <Button
              onPress={logar}
              textoBotao={"Entrar"}
              estilo={styles.button}
            />

            <LinhaTexto navigation={navigation} />
          </>
        )}

        {/* Main action buttons */}
        <IconButton
          textoBotao={"Pagar meu ticket"}
          iconName={"qrcode-scan"}
          onPress={() => {
            if(IS_WEB){
              setScanTicket(true);
              setAutoLoginMailPass();
              setAutoLogin(true);
            }
            else{
              setShowAlert({
                type: "info",
                title: "Atenção",
                message: "Para usar essa opção, crie primeiro uma conta.",
                show: true,
                confirmText: "OK",
                pressConfirm: () => {
                  navigation.navigate("Cadastro");
                  setShowAlert({ ...showAlert, show: false });
                },
              });
            }
          }}
          estilo={[styles.button, styles.highlightedButton]}
        />

        <IconButton
          textoBotao={"Fazer Login"}
          iconName={"login"}
          onPress={() => setShowLoginFields(!showLoginFields)}
          estilo={[styles.button, styles.loginButton]}
        />

        <IconButton
          textoBotao={"Histórico"}
          iconName={"history"}
          onPress={() => {
            if(IS_WEB){
              setGoHistory(true);
              setAutoLoginMailPass();
              setAutoLogin(true);
            }
            else{
              setShowAlert({
                type: "info",
                title: "Atenção",
                message: "Para usar essa opção, crie primeiro uma conta.",
                show: true,
                confirmText: "OK",
                pressConfirm: () => {
                  navigation.navigate("Cadastro");
                  setShowAlert({ ...showAlert, show: false });
                },
              });
            }
          }}
          estilo={[styles.button, styles.historyButton]}
        />

        {!showLoginFields && (
          <View style={styles.downloadAppTextContainer}>
            <Icon name="download" size={20} color={Colors.HYPERLINK} style={{ marginRight: 8 }} />
            <Text
              style={styles.downloadAppText}
              onPress={handleDownloadApp}
            >
              Baixar App
            </Text>
          </View>
        )}

        <BetterAlert {...showAlert} />
        <MessageTypeModal
          show={showMessageModal}
          onPressMessage={(messageValue) => onPressMessage(messageValue)}
          title={"Seu usuario ainda não foi confirmado."}
        />
      </SafeAreaView>
    </KeyboardAvoidingView>
  );

  function loginSuccessfully() {
    setIsSignUp(true);
    AsyncStorage.getItem("startsWithDigitalCredential").then((value) => {
      JSON.parse(value) ? navigation.navigate("DigitalCredential") : null;
    });
    if(pressDigitalCredential) navigation.navigate("DigitalCredential")
    setEmailUser(email);
    setShowAlert({ ...showAlert, show: false });
    setEmail("");
    setPassword("");
    setIsAuthenticated(false);
    setIsFirstLogin(false);
    setPressDigitalCredential(false);
    setLoading({ show: false, message: "" });

    if (goHistory) {
      navigation.navigate("PaymentSessionHistory");
      setGoHistory(null);
    }
    // Navigate to PaymentTicket only after successful login if we have a ticket parameter
    if (ticketParam) {
      navigation.navigate("PaymentTicket", ticketParam);
      setTicketParam(null); // Clear the ticket parameter after navigation
    }
    if (scanTicket) {
      navigation.navigate("ScanQRCode");
      setScanTicket(null);
    }
  }

  async function logar() {
    try {
      if (!Validate.Email(email)) {
        setValidEmail({ ...validEmail, isValid: false });
      } else if (password == "") {
        setValidEmail({ ...validEmail, isValid: true });
        setValidPassword({ ...validPassword, isValid: false });
      } else {
        setValidPassword({ ...validPassword, isValid: true });
        setValidEmail({ ...validEmail, isValid: true });

        if(IS_WEB && autoLogin){
          setLoginType("autologin");
          setLoading({ show: true, message: "Sem autenticação" });
        }
        else{
          setLoginType("manual");
          setLoading({ show: true, message: "Logando" });
        }
        Login(email, password, null)
          .then((response) => {
            if (response.statusCode) {
              SecureStorage.setItemAsync("TokenUser", response.reason);
              setRolelUser(response.role ?? "user");
              setIsAdminUser(response.isAdmin ?? false);
              if (hasBiometry == null) {
                setLoading({ show: false, message: "" });

                if(IS_WEB) {
                  AsyncStorage.setItem("biometria", "não").then(() =>
                    loginSuccessfully()
                  );
                }
                else{
                  setShowAlert({
                    type: "info",
                    title: `Usar ${securityType}?`,
                    message: `Deseja realizar o login com o ${securityType} sempre que for logar no app?`,
                    show: true,
                    cancelText: "Não",
                    confirmText: "Sim",
                    pressCancel: () => {
                      AsyncStorage.setItem("biometria", "não").then(() =>
                        loginSuccessfully()
                      );
                    },
                    pressConfirm: () => {
                      AsyncStorage.setItem("biometria", "sim").then(() => {
                        SecureStorage.setItemAsync("email", email);
                        SecureStorage.setItemAsync("password", password);
                        loginSuccessfully();
                      });
                    },
                  });
                }
              } else if (
                hasBiometry == "sim" &&
                (email != emailBiometry || password != passwordBiometry)
              ) {
                setLoading({ show: false, message: "" });
                setShowAlert({
                  type: "info",
                  title: `Detectamos uma mudança de login`,
                  message: `Deseja alterar o login com ${securityType}?`,
                  show: true,
                  cancelText: "Não",
                  confirmText: "Sim",
                  pressCancel: () => loginSuccessfully(),
                  pressConfirm: () => {
                    SecureStorage.setItemAsync("email", email);
                    SecureStorage.setItemAsync("password", password);
                    loginSuccessfully();
                  },
                });
              } else {
                if (saveLoginAuth) {
                  SecureStorage.setItemAsync("email", email);
                  SecureStorage.setItemAsync("password", password);
                }
                loginSuccessfully();
              }
            } else {
              let msgErro = response.reason;
              let resendConfirmationEmail = false;
              msgErro ==
              "O email ainda não foi confirmado, por favor tente novamente."
                ? (resendConfirmationEmail = true)
                : (resendConfirmationEmail = false);
              if (resendConfirmationEmail) {
                setShowMessageModal(true);
              } else {
                setShowAlert({
                  type: "alert",
                  title: "Atenção",
                  message: msgErro,
                  show: true,
                  confirmText: "Tentar novamente",
                  pressConfirm: () => {
                    setShowAlert({ ...showAlert, show: false });
                    if(IS_WEB && ticketParam){
                      // Clear fields on error
                      setEmail("");
                      setPassword("");
                      setTicketParam(null);
                    }
                  },
                });
              }
            }
          })
          .catch((error) => {
            let msgErro =
              "Não foi possível realizar o login\n" +
                (error.reason ?? error.erro) ?? "Não informado";
            setShowAlert({
              type: "alert",
              title: "Erro",
              message: msgErro,
              show: true,
              confirmText: "Vou verificar",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
                if(IS_WEB && ticketParam){
                  // Clear fields on error
                  setEmail("");
                  setPassword("");
                  setTicketParam(null);
                }
              },
            });
          })
          .finally(() => setLoading({ show: false, message: "" }));
      }
    } catch (error) {
      setLoading({ show: false, message: "" });
      let msgErro = "Não foi possível realizar o login" + error;
      if (String(error).toLowerCase().includes("not found")) {
        msgErro =
          "O seu email ou senha está incorreto, por favor verifique e tente novamente!";
        setShowAlert({
          type: "alert",
          title: "Erro",
          message: msgErro,
          show: true,
          confirmText: "Vou verificar",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
            if(IS_WEB && ticketParam){
              // Clear fields on error
              setEmail("");
              setPassword("");
              setTicketParam(null);
            }
          },
        });
      }
    }
  }

  function setAutoLoginMailPass(){
    if(IS_WEB){
      setEmail("suporte@softcasenet.com.br");
      setPassword("trevoapp01");
    }
  }
}

const styles = StyleSheet.create({
  logoPequeno: {
    marginBottom: 10,
    resizeMode: "stretch",
    width: 240,
    height: 74,
  },
  inputLogin: {
    fontSize: Fonts.FONT_SIZE_20,
    textAlign: "center",
    marginBottom: 20,
    fontWeight: Fonts.FONT_BOLD.fontWeight,
    color: Colors.WELCOME_TEXT,
  },
  container: {
    marginTop: 24,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.WHITE,
  },
  button: {
    width: "70%",
  },
  highlightedButton: {
    backgroundColor: Colors.ALERT,
    marginBottom: 16,
  },
  loginButton: {
    backgroundColor: Colors.PRIMARY,
    marginBottom: 16,
  },
  historyButton: {
    backgroundColor: Colors.BLACK,
    marginBottom: 16,
  },
  downloadAppText: {
    color: Colors.HYPERLINK,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
    textDecorationLine: "underline",
  },
  downloadAppTextContainer: {
    marginTop: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});
function setBiometry(
  hasBiometryStorage,
  emailStg,
  passwordStg,
  setHasBiometry,
  setEmailBiometry,
  setPasswordBiometry,
  setSaveLoginAuth
) {
  if (hasBiometryStorage == "sim" && emailStg && passwordStg) {
    setHasBiometry(hasBiometryStorage);
    setEmailBiometry(emailStg);
    setPasswordBiometry(passwordStg);
  }
  if (hasBiometryStorage == "sim" && !emailStg && !passwordStg) {
    setSaveLoginAuth(true);
  }
}
